export function normalizeDoQueries(q) {
    if (!q || typeof q !== 'string') return q;
    let s = q.trim();
    // 1) how do i / you / we / they / we -> how to
    s = s.replace(/\bhow\s+do\s+(i|you|we|they)\b/i, 'how to');
  
    // 2) how do i <verb> -> how to <verb> (covers "how do i borrow a book")
    s = s.replace(/\bhow\s+do\s+(i|you|we|they)\s+([a-z0-9'’]+)\b/i, (m, p1, p2) => {
      return `how to ${p2}`;
    });
  
    // 3) where do i / you / we / they -> where to
    s = s.replace(/\bwhere\s+do\s+(i|you|we|they)\b/i, 'where to');
  
    // 4) what do i need to X -> what is needed to X  OR how to X
    s = s.replace(/\bwhat\s+do\s+(i|you|we|they)\s+need\s+to\s+/i, 'what is needed to ');
  
    // 5) do I/you/we <verb> something? -> convert common "do i" start to "to" for intent matching
    // only if starts with "do" and followed by pronoun+verb
    s = s.replace(/^\s*do\s+(i|you|we|they)\s+([a-z0-9'’]+)\b/i, (m,p1,p2) => `how to ${p2}`);
  
    // 6) collapse multiple spaces, trim
    s = s.replace(/\s+/g, ' ').trim();
  
    return s;
  }

  export const cleanText = (text) => {
    if (!text || typeof text !== 'string') return '';
    const urlRegex = /(https?:\/\/[^\s<]+)/g;
    return text
      .replace(/\[Internal FAQ\]/gi, '')
      .replace(/�/g, '\n')
      .replace(/<mailto:[^>]+>/g, '')
      .replace(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g, '$1')
      .replace(urlRegex, '<a href="$1" target="_blank">$1</a>')
      .replace(/[^\w\s.,!?&()\-/:%@$#=+;'"[\]\n<>]/g, '')
      .replace(/[ \t]{2,}/g, ' ')
      .trim();
  };
  
  export function extractLevelFromText(text) {
    if (!text) return null;
  
    const levelRegex = /level\s*(\d)/i; // matches "Level 1", "level2", etc.
    const match = text.match(levelRegex);
    if (match && match[1]) {
      return parseInt(match[1], 10);
    }
    return null;
  }  

    // const onChangeKeyboard = (input) => {
  //   setKeyboardInput(input);
  //   if (keyboardRef.current) {
  //     keyboardRef.current.setInput(input);
  //   }
    // if (showKeyboard) {
    //   if (keyboardInput === query) setQuery(input);
    //   else setChatInput(input);
    // }
  // };

  // const onKeyPress = (button) => {
  //   if (button === '{enter}') {
  //     if (keyboardInput === query) {
  //       handleInitialQuery();
  //       setInitialComponentClicked('others')
  //     }
  //     else handleChatContinue();
  //     // setShowKeyboard(false);
  //   } else if (button === '{shift}' || button === '{lock}') {
  //     // Handle shift or lock if needed
  //   } else if (button === '{bksp}') {
  //     setKeyboardInput(keyboardInput.slice(0, -1));
  //   } else if (button === '{close}'){
  //     // setShowKeyboard(false);
  //   }
  // };
